import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import 'rxjs/add/operator/map';

import { Role } from './role.model';
import { RoleService } from './role.service';

@Injectable()
export class RoleResolver implements Resolve<Role | Role[]> {
  constructor(private roleService: RoleService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Role> | Observable<Role[]> {
    if ('roleId' in route.params) {
      return this.roleService.getById(route.params.roleId);
    }
    return this.roleService.get();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/data/roles/role.resolver.ts